import { PrivacyBanner, PrivacyBannerColor } from '@components/Layouts';
import { Route, Routes } from '@navigation';
import { StyleProps } from '@styles';
import { scrollToTop, TestIdProps } from '@utils';
import React, { FC } from 'react';

import LogoIcon from './assets/logo.inline.svg';
import FooterExpanded from './components/Expanded';
import FooterSignupNewsletter from './components/SignupNewsletter';
import FooterSocials from './components/Socials';

interface Props extends StyleProps, TestIdProps {
  privacyBannerColor?: PrivacyBannerColor;
}

export const Footer: FC<Props> = ({ testId, style, className, privacyBannerColor }) => {
  const renderLinks = (links: Route[], target?: string) => {
    return links.map((r, idx) => (
      <li
        key={r.label}
        className={`hover:text-accent-orange text-ocean-blue font-medium text-sm ${idx === links.length - 1 ? '' : 'mb-4'}`}
      >
        <a target={target} className="leading-5" href={r.url} onClick={() => (r.url.startsWith('/') ? scrollToTop() : undefined)}>
          {r.label}
        </a>
      </li>
    ));
  };

  return (
    <footer data-testid={testId} style={style} className={className}>
      <PrivacyBanner testId={testId ? `${testId}-privacy-banner` : undefined} color={privacyBannerColor} />
      <div style={{ height: 5 }} className="w-full bg-accent-green"></div>
      <div className="container mx-auto px-8 md:px-20 pt-16">
        <div className="flex flex-col lg:flex-row justify-between">
          <div className="w-full lg:w-4/12 mb-16 lg:mb-0">
            <LogoIcon />
            <a href="mailto:hello@circleof.com" className="text-sm text-ocean-blue font-medium not-italic mt-2 block">
              hello@circleof.com
            </a>
            <address className="mt-4 text-sm text-ocean-blue font-medium not-italic">
              1355 Market Street, Suite 488 <br />
              San Francisco, CA 94103
            </address>
          </div>
          <div className="w-full lg:w-4/12 flex flex-row lg:-mx-5 lg:mb-0 mb-8">
            <ul className="w-full lg:w-6/12 lg:px-5">
              {renderLinks([Routes.getExtraHelp, Routes.guidesAndTips, Routes.app, Routes.about, Routes.helpCenter])}
            </ul>

            <ul className="w-full lg:w-6/12 lg:px-5">
              {renderLinks([Routes.editorialPolicy, Routes.privacyPolicy, Routes.terms, Routes.affiliateDisclosure], '_blank')}
            </ul>
          </div>

          {/* Expanded for mobile*/}
          <FooterExpanded className="lg:hidden mb-10" />

          <div className="w-full lg:w-4/12 lg:mb-0 mb-8">
            <FooterSignupNewsletter />
          </div>
        </div>
        {/* Expanded for desktop*/}
        <FooterExpanded className="hidden lg:block" onLinkClick={scrollToTop} />

        <FooterSocials testId={testId ? `${testId}-socials` : undefined} />
      </div>
      <script id="affilimate-script" async src="https://snippet.affilimate.io"></script>
    </footer>
  );
};

export default Footer;
